import { coreQueryKey } from '@/api/core/authorization';
import { readNativeCatalogFloors } from '@/api/core/native-property-read';
import type { PropertyRuntime } from './property-queries';

/**
 * 층 필터 선택지(facet). q·floor 필터에는 묶이지 않고, 지점(+타입)의 현재 미삭제 Room 전체를 집계한다.
 * 목록을 막지 않는 보조 조회라 실패해도 목록은 그대로 두고 오류만 보인다.
 */
export function nativeCatalogFloorsQuery(
  runtime: PropertyRuntime,
  generation: number,
  propertyId: string,
  roomTypeId: string | null,
  enabled: boolean,
) {
  return {
    queryKey: [
      ...coreQueryKey(runtime.apiNamespace, generation, 'native-property-catalog', propertyId),
      'floors',
      roomTypeId,
    ],
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      readNativeCatalogFloors(runtime.client, propertyId, roomTypeId, signal),
    enabled,
    retry: false as const,
    staleTime: 0,
    gcTime: 0,
    meta: { suppressGlobalError: true },
  };
}
